import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DeviceDetectorService} from 'ngx-device-detector';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {ActivityQuote} from '../../../../data/project/activity/activity-quote';
import {ProjectActivityService} from '../../../../data/project/activity/project-activity.service';
import {ConfirmationService} from 'primeng/api';
import {PdfPreviewDialogComponent} from '../../../pdf-preview-dialog/pdf-preview-dialog.component';
import {ProjectService} from '../../../../data/project/project.service';
import {ShortProject} from '../../../../data/project/short-project';

@Component({
  selector: 'app-quotes-email-dialog',
  templateUrl: './quotes-email-dialog.component.html',
  styleUrls: ['./quotes-email-dialog.component.scss'],
  providers: [
    ConfirmationService,
    DeviceDetectorService]
})
export class QuotesEmailDialogComponent implements OnInit {

  dialogHeader: string;
  link: string;

  showSendButton = true;

  textAreaMessage: string;

  submitLoading: boolean;

  showLoadingSpinner: boolean;

  canBeEdited: boolean;

  isMobile: boolean;

  activityQuote: ActivityQuote;

  constructor(
    private projectService: ProjectService,
    private projectActivityService: ProjectActivityService,
    private miscSnackBarService: MiscSnackBarService,
    protected deviceDetectorService: DeviceDetectorService,
    protected confirmationService: ConfirmationService,
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<QuotesEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      activityQuote: ActivityQuote,
      project: ShortProject,
      dialogHeader: string,
      showSendButton: boolean,
      resolved: boolean;
    }
  ) {
    this.dialogHeader = data.dialogHeader;
    this.activityQuote = data.activityQuote;
  }

  ngOnInit() {
    this.showLoadingSpinner = true;

    if (this.activityQuote.awardSent) {
      this.textAreaMessage = this.activityQuote.awardMsg

      this.showLoadingSpinner = false;
    } else if (this.activityQuote.sentDate || this.activityQuote.price) {
      this.projectActivityService.getActivityAwardEmail(this.activityQuote.id).subscribe(msg => {
        this.textAreaMessage = msg.text

        this.showLoadingSpinner = false;
      })
    } else {
      this.projectActivityService.getActivityQuoteEmail(this.activityQuote.id).subscribe(msg => {
        this.textAreaMessage = msg.text

        this.showLoadingSpinner = false;
      })
    }

    this.dialogHeader = this.activityQuote.addressee.email


    this.isMobile = this.deviceDetectorService.isMobile();
  }

  cancelQuote() {
    this.confirmationService.confirm({
      header: `Quote for ${this.activityQuote.addressee.email}`,
      message: `Are you sure you would like to cancel this award?`,
      accept: () => {
        this.projectActivityService.cancelActivityQuoteEmail(this.activityQuote.id).subscribe(() => {
          this.miscSnackBarService.openSuccessSnackBar('Award Successfully Cancelled!')

          this.dialogRef.close(['Cancelled!']);
        }, error => {
          this.miscSnackBarService.openErrorSnackBar(error.message)
        })
      }
    });

  }

  openLastDrawing(): void {
    this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.data.project.name,
        link: '/project/' + this.data.project.id + '/files/last-drawing',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  sendQuote() {
    this.submitLoading = true;

    this.projectActivityService.sendActivityQuoteEmail(this.activityQuote.id, this.activityQuote.sentTo, this.textAreaMessage).subscribe(() => {
      this.miscSnackBarService.openSuccessSnackBar('Quote Successfully sent!')

      this.submitLoading = false;
      this.dialogRef.close(['Success!']);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.submitLoading = false;
    })
  }

  sendAward() {
    this.submitLoading = true;

    this.projectActivityService.sendActivityAwardEmail(this.activityQuote.id, this.activityQuote.sentTo, this.textAreaMessage).subscribe(() => {
      this.miscSnackBarService.openSuccessSnackBar('Award Successfully sent!')

      this.submitLoading = false;
      this.dialogRef.close(['Success!', 'Awarded']);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.submitLoading = false;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

}
